/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.button`
	font-size: 16px;
	background: transparent;
	color: #475773;
    padding: 10px 24px;
    border-radius: 12px;
    border: 2px solid #475773;
    margin-top: 17px;  
`;



// WEBPACK FOOTER //
// ./src/components/auth-form/button.js